import { Watchlist } from "@/components/Watchlist";
import { ConsultationBooking } from "@/components/ConsultationBooking";
import { Portfolio } from "@/components/Portfolio";
import { MyEnquiries } from "@/components/MyEnquiries";
import { ClientShell, useClientUser } from "@/pages/client/ClientShell";

const displayEmail = (e) => (e && !e.endsWith("@phone.preipo") ? e : "");

const SECTIONS = {
  portfolio: { title: "My Portfolio", blurb: "Wallet balance, invested total and every holding with its order timeline.", render: () => <Portfolio /> },
  alerts: { title: "Price Alerts", blurb: "Shares you are watching — we email you when the price moves or crosses your target.", render: () => <Watchlist /> },
  consult: { title: "Book a Consultation", blurb: "Pick a slot with the desk for a one-to-one discussion.", render: (u) => <div className="mt-6"><ConsultationBooking defaultName={u.name || ""} defaultEmail={displayEmail(u.email)} /></div> },
  enquiries: { title: "My Enquiries", blurb: "Every quote request you have sent to the desk and its current pipeline status.", render: () => <MyEnquiries /> },
};

// Former Investor Panel tabs, now rendered inside the single Client Portal shell.
export default function ClientSection({ kind }) {
  const user = useClientUser();
  if (!user) return null;
  const s = SECTIONS[kind];
  return (
    <ClientShell user={user} title={s.title}>
      <p className="mt-2 text-sm text-slate-500">{s.blurb}</p>
      <div data-testid={`client-section-${kind}`}>{s.render(user)}</div>
    </ClientShell>
  );
}
